import { AI_AGENT_MGPT_SERVICE_CHANNELS } from '../constants/aiAgentOptions';

import type { ICompanyServiceChannel } from '../apis/company/types';
import type { AiAgentMgptServiceChannel } from '../constants/aiAgentOptions';

const AI_AGENT_EXTENSION_ID = 1;
const AI_AGENT_TARGET_SERVICE_SET = new Set<string>(Object.values(AI_AGENT_MGPT_SERVICE_CHANNELS));

export const isAiAgentTargetService = (service: string): service is AiAgentMgptServiceChannel =>
  AI_AGENT_TARGET_SERVICE_SET.has(service);

export const filterAiAgentTargetServices = (services?: readonly string[] | null): AiAgentMgptServiceChannel[] =>
  services?.filter(isAiAgentTargetService) ?? [];

export const isScautrAiAgentEnabled = (channels?: readonly ICompanyServiceChannel[] | null): boolean => {
  const scautrChannel = channels?.find((channel) => channel.name === AI_AGENT_MGPT_SERVICE_CHANNELS.SCAUTR);

  if (scautrChannel?.used !== 'Y') {
    return false;
  }

  return scautrChannel.extension.some((extension) => extension.extensionId === AI_AGENT_EXTENSION_ID && extension.used === 'Y');
};

export const isProgixAiAgentEnabled = (channels?: readonly ICompanyServiceChannel[] | null): boolean => {
  const progixChannel = channels?.find((channel) => channel.name === AI_AGENT_MGPT_SERVICE_CHANNELS.PROGIX);

  if (progixChannel?.used !== 'Y') {
    return false;
  }

  return progixChannel.extension.some((extension) => extension.extensionId === AI_AGENT_EXTENSION_ID && extension.used === 'Y');
};

export const isProdoqAiAgentEnabled = (channels?: readonly ICompanyServiceChannel[] | null): boolean => {
  const prodoqChannel = channels?.find((channel) => channel.name === AI_AGENT_MGPT_SERVICE_CHANNELS.PRODOQ);

  if (prodoqChannel?.used !== 'Y') {
    return false;
  }

  return true;
};
